import React from "react";

import CableIcon from "@mui/icons-material/Cable";
import CellTowerIcon from "@mui/icons-material/CellTower";
import ScienceIcon from "@mui/icons-material/Science";
import { Box, Chip } from "@mui/material";

import { SENSOR_CHIP_SX } from "components/sensors/table/chips/sensor-chip-style";
import { NO_VALUE_TEXT_SX } from "components/sensors/table/no-value-text";

const PILL_WIDTH = "110px";

export function ConnectionTypeChip({
  connectionType,
}: {
  connectionType: string;
}) {
  if (connectionType === "Unknown") {
    return (
      <Box component="span" sx={NO_VALUE_TEXT_SX}>
        Unknown
      </Box>
    );
  }
  const icon =
    connectionType === "Cellular" ? (
      <CellTowerIcon fontSize="small" />
    ) : connectionType === "Ethernet" ? (
      <CableIcon fontSize="small" />
    ) : connectionType === "Test" ? (
      <ScienceIcon fontSize="small" sx={{ color: "text.disabled" }} />
    ) : undefined;
  return (
    <Chip
      size="small"
      icon={icon}
      label={connectionType}
      sx={{ ...SENSOR_CHIP_SX, width: PILL_WIDTH }}
    />
  );
}
